import { Dispatch } from 'redux'

import * as Api from 'redux/api/ExportTables'

import { toggleSnackbarOpen } from '../Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'
import { useThunkActions } from '../useThunkActions'
import { TExportTable } from 'types/GlobalExportTable'
import {
  IExportTablePatchBody,
  IExportTablePostBody
} from 'redux/api/ExportTables/types'

import * as actions from './actions'

function tryGetAllExportTables() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    Api.getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryGetOneExportTable(id: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getOne(id))

    Api.getOne(id)
      .then((response) => {
        dispatch(actions.getOneSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getOneFailed(id))
      })
  }
}

function tryCreateExportTable(
  body: IExportTablePostBody,
  callback?: (err?: boolean, data?: TExportTable) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    Api.create(body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.ExportTableCreated))

        if (callback) {
          callback(false, response.data.data)
        }
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.ExportTableCreatedFailed))

        if (callback) {
          callback(true)
        }
      })
  }
}

function tryUpdateExportTable(
  id: string,
  body: IExportTablePatchBody,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    Api.update(id, body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.ExportTableUpdated))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.ExportTableUpdatedFailed))

        if (callback) {
          callback(true)
        }
      })
  }
}

function tryDeleteExportTable(id: string, callback?: (err?: boolean) => void) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    Api.destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess(id))

        dispatch(toggleSnackbarOpen(SnackbarMessage.ExportTableDeleted))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.ExportTableDeletedFailed))

        if (callback) {
          callback(true)
        }
      })
  }
}

function tryAssignApiKeysToExportTable(
  id: string,
  apiKeyIds: string[],
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.assignApiKeys())

    Api.assignApiKeys(id, apiKeyIds)
      .then(() => {
        dispatch(actions.assignApiKeysSuccess({ id, apiKeys: apiKeyIds }))

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.ExportTableApiKeysAssignedSuccess)
        )

        callback?.()
      })
      .catch(() => {
        dispatch(actions.assignApiKeysFailed())

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.ExportTableApiKeysAssignedFailed)
        )

        callback?.(true)
      })
  }
}

export const useExportTableActions = () => {
  return {
    tryGetAllExportTables: useThunkActions(tryGetAllExportTables),
    tryGetOneExportTable: useThunkActions(tryGetOneExportTable),
    tryCreateExportTable: useThunkActions(tryCreateExportTable),
    tryUpdateExportTable: useThunkActions(tryUpdateExportTable),
    tryDeleteExportTable: useThunkActions(tryDeleteExportTable),
    tryAssignApiKeysToExportTable: useThunkActions(
      tryAssignApiKeysToExportTable
    )
  }
}
